var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2439 0.935578C16.5556 1.20834 16.5872 1.68216 16.3144 1.99389L5.81443 13.9939C5.67774 14.1501 5.48242 14.2427 5.27496 14.2496C5.0675 14.2565 4.86645 14.1771 4.71967 14.0303L0.21967 9.53034C-0.0732233 9.23745 -0.0732233 8.76257 0.21967 8.46968C0.512563 8.17679 0.987437 8.17679 1.28033 8.46968L5.21347 12.4028L15.1856 1.00613C15.4583 0.694404 15.9322 0.662816 16.2439 0.935578Z",
    fill: "#0B68FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDone);
export default __webpack_public_path__ + "static/media/task-done.92d5c2e50ef897e33e69909832a7a7c0.svg";
export { ForwardRef as ReactComponent };